import { defineComponent, h, type PropType } from 'vue'
import Editor from './Editor.vue'
import Terminal from './Terminal.vue'
import Browser from './Browser.vue'

export default defineComponent({
  props: {
    size: {
      type: String as PropType<'sm' | 'lg'>,
      default: 'sm',
    },
    frame: {
      type: String,
      required: true,
    },
    windowUrls: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup(props, context) {
    return () =>
      props.frame === 'editor'
        ? h(Editor, { size: props.size, files: props.windowUrls }, context.slots.default)
        : props.frame === 'terminal'
          ? h(Terminal, { size: props.size, cwd: props.windowUrls[0] }, context.slots.default)
          : h(Browser, { size: props.size, location: props.windowUrls[0] }, context.slots.default)
  },
})
